import React, { useState } from 'react';
import SNFDashboardMain from './SNFDashboardMain';
import SNFByThreeVsPy from './SNFByThreeVsPy';
import './ERDashboard.css';

function SNFDashboard() {
  const [activeView, setActiveView] = useState('pyDeepDive');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
      <div className="dashboard-sub-header" style={{
        display: 'flex',
        gap: '12px',
        padding: '8px 20px',
        backgroundColor: '#f9fafb',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{
          display: 'flex',
          gap: '12px',
          alignItems: 'center'
        }}>
          <h2 style={{
            margin: 0,
            fontSize: '20px',
            fontWeight: '700',
            color: '#1f2937',
            letterSpacing: '-0.5px'
          }}>🏥 SNF Dashboard</h2>
        </div>
        <div style={{
          display: 'flex',
          gap: '12px'
        }}>
          <button
            onClick={() => setActiveView('pyDeepDive')}
            style={{
              padding: '10px 20px',
              backgroundColor: activeView === 'pyDeepDive' ? '#4caf50' : '#a5d6a7',
              color: activeView === 'pyDeepDive' ? 'white' : '#2e7d32',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: activeView === 'pyDeepDive' ? '0 2px 8px rgba(76, 175, 80, 0.3)' : 'none'
            }}
          >
            📊 PY DEEP DIVE
          </button>
          
          <button
            onClick={() => setActiveView('by3VsPy')}
            style={{
              padding: '10px 20px',
              backgroundColor: activeView === 'by3VsPy' ? '#0ea5e9' : '#e0f2fe',
              color: activeView === 'by3VsPy' ? 'white' : '#0369a1',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: activeView === 'by3VsPy' ? '0 2px 8px rgba(14, 165, 233, 0.3)' : 'none'
            }}
          >
            📈 PY GENERAL
          </button>
        </div>
      </div>
      <div style={{ 
        flex: 1, 
        overflow: 'auto',
        animation: 'fadeIn 0.3s ease-in-out'
      }}>
        {activeView === 'by3VsPy' ? (
          <SNFByThreeVsPy />
        ) : (
          <SNFDashboardMain activeView={activeView} setActiveView={setActiveView} />
        )}
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default SNFDashboard;
